<template>
	<div class="comp">
		<el-dialog :title="title" :visible.sync="dialogState" width="400px">
			<el-form :model="form" ref="form" :inline="true">
				<el-row>
					<el-col :span="24" >
						<el-form-item label="离院时间：" :label-width="formLabelWidth">
							<el-date-picker style="width:220px" v-model="form.timeRange" :picker-options="{disabledDate(time) {return form.timeRange.getTime() > time.getTime()}}" type="date" :clearable="false" size="small"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="zhuyuanMsg.depositType==1">
					<el-col :span="24">
						<el-form-item label="押金：" :label-width="formLabelWidth">
							<el-input v-model="form.deposit" :rows="4" style="width:220px" placeholder="请输入押金" size="small" clearable>
								<template slot="append">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="经办人：" :label-width="formLabelWidth">
							<el-select style="width:220px;" v-model="form.doctorIndex" clearable placeholder="请选择" size="small">
								<el-option v-for="(item,index) in doctorList" :key="item._id" :label="item.basic_info.nick_name" :value="index">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" >
						<el-form-item label="备注：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.remark" :rows="4" style="width:220px" placeholder="请输入备注" size="small" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				title:'修改住院',
				formLabelWidth: '100px',
				userInfo:{card_info:{}},
				zhuyuanList:[],
				doctorList:[],
				form:{
					// curServiceIndex:'',
					timeRange:'',
					// depositType:1, // (1现金；2余额)
					deposit:'',    // number
					// sale_price:0,
					// payType:'',    //
					doctorIndex:'',
					remark:'',
				},
				// rules: {
				// 	userName: [{ required: true, message: '请输入顾客名称', trigger: 'change' }],
				// }
			}
		},
		props:{
			bingliMsg:{
				default:()=>{
					return {}
				}
			},
			zhuyuanMsg:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			// this.$util.getZhuyuanList().then(list=>{
			// 	this.zhuyuanList = list;
			// })
			
			this.$util.getDoctorList().then(list=>{
				this.doctorList = list;
				
				this.form.timeRange = new Date(parseInt(this.zhuyuanMsg.endDate+'000'));
				this.form.remark = this.zhuyuanMsg.remark;
				this.form.deposit = this.zhuyuanMsg.deposit;
				for(let i=0;i<this.doctorList.length;i++){
					if(this.doctorList[i]._id==this.zhuyuanMsg.handlerId){
						this.form.doctorIndex = i;
					}
				}
			})
			
			// this.$util.getUserInfo(this.bingliMsg.memberId).then(res=>{
			// 	this.userInfo = res;
			// })
		},
		methods: {
			cancel(){
				this.$emit("submit")
			},
			submit(){
				// if(this.form.curServiceIndex===''){
				// 	this.$message({
				// 		message: '请选择住院服务！',
				// 		type: 'error'
				// 	});
				// 	return ;
				// }
				if(this.form.doctorIndex===''){
					this.$message({
						message: '请选择经办人！',
						type: 'error'
					});
					return ;
				}
				// if(this.form.depositType===1){
				// 	if(this.form.deposit==''){
				// 		this.$message({
				// 			message: '请输入押金！',
				// 			type: 'error'
				// 		});
				// 		return ;
				// 	}
				// 	if(this.form.payType===''){
				// 		this.$message({
				// 			message: '请选择押金支付方式！',
				// 			type: 'error'
				// 		});
				// 		return ;
				// 	}
				// }
				let params = {
					"id": this.zhuyuanMsg.id,
					"endDate": "",
					deposit:Number(this.form.deposit),
					"handlerId": this.doctorList[this.form.doctorIndex]._id,
					"handlerName": this.doctorList[this.form.doctorIndex].basic_info.nick_name,
					"remark": this.form.remark
				}
				if(this.form.timeRange){
					params.endDate = new Date(this.form.timeRange).getTime().toString().substr(0,10);
				}
				let loading = this.$loading()
				this.$http.post('/api/InHospital/Update', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",res.data)
					}
				})
			},
			changeAge(){
				let month = parseInt(Number(this.ageYear||0)*12+Number(this.ageMonth||0));
				this.datePickerValue = this.$public.FBirthday(month)
			},
			changeRadio(i){
				if(i===1){
					this.form.deposit = '';
					this.form.payType = '';
				}else{
					this.form.deposit = this.userInfo.card_info.user_yue
					this.form.payType = ''
				}
			},
			changeZhuyuan(index){
				this.form.sale_price = this.zhuyuanList[index].basic_info.price.sale_price;
			},
			changeDatePicker(d){
				let a = this.$public.FAge(d);
				this.ageYear = a[0];
				this.ageMonth = a[1];
			},
			// 选择性别
			changeSex(a){
				this.form.sex = a[0];
				this.form.sterilization = a[1];
			},
			// 修改宠物品种
			changeType(str){
				this.form.type_name=str;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body{
			padding:30px 20px;
			.el-form-item{
				margin-bottom:10px;
			}
		}
	}
</style>
